import { useCallback, useContext, useEffect, useState } from 'react';

import { useGetEmployeeSalaryListByQuery } from '@app/api/EmployeeSalary';
import { useUserPrint } from '@app/hooks';
import { NotificationContext } from '@app/providers';
import { handleCatchError } from '@app/services';

export const useSalaryInfoEffects = () => {
  const [confirmed, setConfirmed] = useState<Record<string, boolean>>({});

  const { showNotification } = useContext(NotificationContext);
  const { activeBranchId: ActiveBranchId, userId } = useUserPrint();

  const { data, isLoading, error } = useGetEmployeeSalaryListByQuery(
    {
      ActiveBranchId,
      userId,
      maxCount: 3,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (error) {
      showNotification(handleCatchError(error));
    }
  }, [error, showNotification]);

  const setInitialConfirmedSalaries = useCallback(() => {
    if (data?.Salaries) {
      const newConfirmed = Object.fromEntries(
        data.Salaries.map((salary, index) => [
          index.toString(),
          !!salary.IsConfirmed,
        ])
      );
      setConfirmed(newConfirmed);
    }
  }, [data?.Salaries]);

  useEffect(() => {
    setInitialConfirmedSalaries();
  }, [data, setInitialConfirmedSalaries]);

  return { data, isLoading, confirmed, setConfirmed };
};
